import type { SelectHTMLAttributes, ReactNode } from 'react';

type AdminFormSelectProps = {
  label: string;
  isLoading?: boolean;
  isError?: boolean;
  children: ReactNode;
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'>;

export default function AdminFormSelect({
  label,
  isLoading,
  isError,
  children,
  ...props
}: AdminFormSelectProps) {
  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm font-bold text-main">{label}</span>
      <select
        className="h-[42px] w-full rounded border border-solid border-border bg-white px-3 text-sm text-main"
        disabled={isLoading || isError || props.disabled}
        {...props}
      >
        {isLoading && <option value="">読み込み中...</option>}
        {isError && <option value="">読み込みに失敗しました</option>}
        {!isLoading && !isError && children}
      </select>
    </label>
  );
}
